import { render } from "./AdmissionTypeChart.vue?vue&type=template&id=169bd6fe"
import script from "./AdmissionTypeChart.vue?vue&type=script&lang=js"
export * from "./AdmissionTypeChart.vue?vue&type=script&lang=js"
script.render = render

export default script